import { render, staticRenderFns } from "./CarrierTrackingLink.vue?vue&type=template&id=e6f6aecc&scoped=true&"
import script from "./CarrierTrackingLink.vue?vue&type=script&lang=js&"
export * from "./CarrierTrackingLink.vue?vue&type=script&lang=js&"
import style0 from "./CarrierTrackingLink.vue?vue&type=style&index=0&id=e6f6aecc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f6aecc",
  null
  
)

export default component.exports